import { formatDate } from '@/business/utils/dateUtil'

const initialJsycData = () => {
  return {
    departCity: '', // 出发城市
    arriveCity: '', // 到达城市
    fromAddressPoi: null,
    fromArea: null,
    fromAddress: '', // 出发详细地址
    fromLon: 0, // 出发经度
    fromLat: 0, // 出发纬度
    toAddressPoi: null,
    toArea: null,
    toAddress: '',
    toLon: 0,
    toLat: 0,
    startTime: `${formatDate().date} ${formatDate().hm}`,
    startTimeName: `${formatDate().monDayWeek} ${formatDate().hm}`,
    useType: 8, // 用车类型 8即时 9预约 ,
    cacheId: '',
    empId: '', // 乘车人Id
    empName: '', 
    phoneNumber: '', // 乘车人手机号
    carTypeList: [], // 查询的车型
    carCheckList: [], // 选中的车型列表
  }
}

const car = {
  namespaced: true,
  state: {
    carSearchInfo: {
      violate: {}, // 本次违背信息
      Ccsqd: {}, // 出差申请单
    },
    travelerList: [],
    jsycData: initialJsycData(),
    carList:[],
    carCcsqdNodata:''
  },
  getters: {//getters属性理解为所有组件的computed属性, 也就是计算属性 
    carSearchInfo: (state) => {
      return state.carSearchInfo || {}
    },
    jsycData: (state) => {
      return state.jsycData || {}
    },
    travelerList: (state) => {
      return state.travelerList || []
    },
    carList: (state) => {
      return state.carList || []
    }
  },
  mutations: { //mutaions理解为store中的methods
    carSearchInfo (state, payload) {
      state.carSearchInfo = payload
    },
    travelerList (state, payload) {
      state.travelerList = payload
    },
    setCarList (state, payload) {
      state.carList = payload
    },
    SET_VIOLATELIST (state, payload) {//违背原因回显
      state.carSearchInfo.violate = payload
    },
    CLEAR_ALL (state) {
      state.jsycData = initialJsycData()
      state.carSearchInfo = {
        violate: {}, // 本次违背信息
        Ccsqd: {}, // 出差申请单
      }
      state.travelerList = []
      state.carList = []
    },
    CARNodata(state,payload){
      state.carCcsqdNodata=payload
    }
  },
  actions: { //添加actions actions中可以包含异步操作
  }
}
export default car